document.querySelectorAll('.product-content-container .product-info .theaccordionheading')
  .forEach(function(theaccordion) {
    const theaccordionnext = theaccordion.nextElementSibling;

    if (!theaccordionnext || !theaccordionnext.classList.contains('theaccordioncontent')) {
      let parent = theaccordion;
      while (parent && !parent.classList.contains('accordion')) {
        parent = parent.parentElement;
      }
      if (parent) {
        parent.style.display = 'none';
      }
    }
  });